<template>
    <div>
        <vx-card title="TAXAS" class="mb-base overflow-hidden border border-dashed d-theme-border-grey-light">
            <div v-for="(tax, index) in taxes" :key="index" :class="{'mt-4': index}">
                <div class="flex justify-between">
                    <div class="flex flex-col">
                        <span class="mb-1 font-bold text-primary">{{ tax.description.toUpperCase() }}</span>
                        <h4 class="mt-5">
                            <span v-if="windowWidth < 480"> {{ tax.value | currency }} </span>
                            <number
                                v-else
                                ref="totalPaid"
                                :to="tax.value"
                                :format="(number) => $options.filters.currency(number)"
                                :duration="0.6"
                                :delay="0.5"
                                easing="Power1.easeOut"
                            />
                        </h4>
                    </div>

                    <div class="flex flex-col">
                        <vs-input-number class="-mt-2" color="danger" label="Rateio" v-model="average" :min="1"/>
                        <h4 class="mt-2 text-right">
                            <span v-if="windowWidth < 480"> {{ dividedAveragePercent | currency }} </span>
                            <number
                                v-else
                                ref="totalPaid"
                                :to="dividedAveragePercent"
                                :format="(number) => $options.filters.currency(number)"
                                :duration="0.6"
                                :delay="0.5"
                                easing="Power1.easeOut"
                            />
                        </h4>
                    </div>
                   
                </div>
                <vs-progress :percent="tax.percent" ></vs-progress>
            </div>

            <div slot="no-body-bottom" class="flex justify-between text-center">
                <div class="w-full border border-dashed d-theme-border-grey-light border-r-0 border-b-0 border-l-0">
                    <p class="mt-4">TOTAL</p>
                    <p class="mb-4 text-3xl font-semibold">
                        <number
                            ref="totalPaid"
                            :to="totalSum"
                            :format="(number) => $options.filters.currency(number)"
                            :duration="0.6"
                            :delay="0.5"
                            easing="Power1.easeOut"
                        />
                    </p>
                </div>
            </div>
        </vx-card>
    </div>
</template>

<script>
    export default {
        props : {
            dataTaxes : {
                required : true,
                type : Array
            }
        },

        data () {
            return {
                totalSum : 0,
                average : 1
            }
        },


        computed : {
            dividedAveragePercent () {
                let taxes = [...this.dataTaxes]
                const average = this.average > 0 ? this.average : 1
                const total = taxes.map(tax => tax.type == 'percentage' ? tax.value / average : 0)[0]

                return total
            },

            taxes () {
                this.totalSum = 0;
                let taxes = [...this.dataTaxes]
                let totalValue = taxes.reduce((acumulator, current ) => acumulator + current.value, 0)
                taxes.forEach(tax => {
                    this.totalSum += tax.value
                    tax.percent = (tax.value * 100) / totalValue
                })
                return taxes.sort((a, b) => a.value - b.value)
            },

            windowWidth() {
                return this.$store.state.windowWidth
            },
        }
    }
</script>